import { Injectable } from "@angular/core";
import { ApiService } from './api.service';
import { NivelInterface } from "../models/nivel.model";
import { CaracterInterface } from "../models/caracter.model";

@Injectable({
  providedIn: 'root'
})

export class CaracterService extends ApiService<CaracterInterface>{
  url="caracteres"
}
